<template>
  <div class="d-flex justify-content-center align-items-center h-100 bg-sachlich-white border">
    <div class="row">
      <div class="col">
        <div class="loader-label text-center">
          {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
      default: null
    }
  },
})
</script>

<style lang="scss" scoped>
  .loader-label {
    font-size: 20px;
  }
</style>
